import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { Button } from '@/components/Button'
import {
  DialogTrigger,
  Modal,
  Dialog,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from '@/components/Modal'

import { TempMealOfDayDivision } from '@/api/types'
import { useTranslation } from 'react-i18next'
import MealOfDayDivisionEditor from './MealOfDayDivisionEditor'

type Props = {
  onAdd: (profile: TempMealOfDayDivision) => void
}
export default function MealOfDayDivisionCreate({ onAdd }: Props) {
  const { t } = useTranslation()
  const [mealOfDayDivision, setMealOfDayDivision] = React.useState<TempMealOfDayDivision | null>(
    null,
  )
  return (
    <DialogTrigger>
      <Button variant="icon" className="HouseholdSelector-add">
        <FontAwesomeIcon icon={faPlus} width={10} height={10} color="var(--gray-500)" />
      </Button>
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>New meal division</ModalHeader>

              <ModalContent style={{}}>
                <MealOfDayDivisionEditor onChange={setMealOfDayDivision} />
              </ModalContent>
              <ModalFooter onClose={close}>
                <Button
                  isDisabled={!mealOfDayDivision}
                  variant="primary"
                  onPress={() => {
                    if (mealOfDayDivision) {
                      onAdd(mealOfDayDivision)
                    }
                    close()
                  }}>
                  Add
                </Button>
              </ModalFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
